module.exports = __webpack_public_path__ + "media/images/property-2-292b90c1b4d3c169706a1892db707c71.png";